<div class="p-fluid p-formgrid grid {{cardStyle}}">
    <shared-loader [hidden]="!_showLoader"></shared-loader>
    <div class="field col-12 md:col-6 mb-0">
        <label for="tipoDocumento">Tipo de documento</label>
        <p-dropdown id="tipoDocumento"
                    class="p-0"
                    showError
                    [options]="_tiposDocumento"
                    [(ngModel)]="_tipoDocumento"
                    [required]="true"
                    optionLabel="nombre" [showClear]="true"
                    placeholder="Tipo de documento" [pTooltip]="_tipoDocumento?'':'Seleccione el tipo de documento'"
                    tooltipPosition="top" [scrollHeight]="'100px'">
        </p-dropdown>

    </div>
    <div class="field col-12 md:col-6 -mt-1">
        <div class="formgroup-inline align-items-start">
            <div class="field col-12 md:col-8 -mt-1">
                <label for="documento">Búsqueda por documento</label>
                <p-inputMask
                    id="documento"
                    [(ngModel)]="documento"
                    [disabled]="_tipoDocumento == null"
                    class="p-2"
                    [pTooltip]="documento ? 'Ingresar número documento' : ''"
                    tooltipPosition="top"
                    [mask]="_tipoDocumento != null ? _tipoDocumento.mascara : '99999999-9'"
                    placeholder="Número documento">
                </p-inputMask>
                <span class="text-700 pl-3 text-sm p-error">
        Este campo se limpia automáticamente
      </span>
            </div>
            <div class="flex field col-3 md:col-2 lg:col-2 mb-0 mt-3 pl-0 gap-2">
                <p-button
                    icon="pi pi-search"
                    [disabled]="_tipoDocumento == null || documento == undefined"
                    [pTooltip]="'Clic para realizar búsqueda'"
                    (onClick)="this.consultaPorTipoDocumento(this._tipoDocumento?.idTipoDocumento!)"
                    styleClass="p-button-rounded p-button-success">
                </p-button>
                <p-button
                    icon="pi pi-times"
                    [disabled]="_tipoDocumento == null || documento == undefined"
                    [pTooltip]="'Limpiar búsqueda'"
                    (onClick)="this.personasService.limpiarSeleccion()"
                    styleClass="p-button-rounded p-button-danger">
                </p-button>
                <p-button
                    *ngIf="this.personasService.noresults() && this.typeFilter == 1 && !this.registroService.preregistroExito()"
                    icon="pi pi-plus"
                    [disabled]="_tipoDocumento == null || documento == undefined"
                    [pTooltip]="'Registrar nueva persona'"
                    (onClick)="this.openDialogNuevaPersona()"
                    styleClass="p-button-rounded p-button-info">
                </p-button>
                <ng-container *ngTemplateOutlet="bottonAddTemplate; context: { clickEvent: onItemClickedButtonAdd.bind(this,typeFilter)}"></ng-container>
            </div>
        </div>
    </div>
</div>

<!--Renderiza solo parte de template responseUsuario-->
<ng-container *ngIf="typeFilter==2">
    <ng-container *ngTemplateOutlet="responseUsuario"></ng-container>
</ng-container>

<ng-template #responseUsuario>
    <div class="p-fluid p-formgrid grid {{cardStyle}}" *ngIf="this.personasService.selected()!=null">
        <div class="field col-12 md:col-6 mb-0">
            <label for="nombres">{{this.personasService.textTipoDoc()}}</label>
            <input
                [value]=" this.personasService.findDocumentoFirst(this.personasService.selected().documentos)?.documento"
                class="p-2 inpt-disabled"
                placeholder="Dui" [disabled]="true" pInputText
                id="dui" pKeyFilter="alpha"/>
        </div>
        <div class="field col-12 md:col-6 mb-0">
            <label for="tipoPersona">Tipo Persona</label>
            <input id="tipoPersona"
                   class="p-2 inpt-disabled"
                   [value]="this.personasService.selected().tipoPersona"
                   placeholder="Tipo persona"
                   [disabled]="true" pInputText
                   pKeyFilter="alpha"/>
        </div>
        <div class="field col-12 md:col-6 mb-0">
            <label for="nombres">Nombres</label>
            <input [value]="this.personasService.selected().nombres"
                   class="p-2 inpt-disabled"
                   placeholder="Nombres" [disabled]="true" pInputText
                   id="nombres" pKeyFilter="alpha"/>
        </div>
        <div class="field col-12 md:col-6 mb-0">
            <label for="apellidos">Apellidos</label>
            <input [value]="this.personasService.selected().apellidos"
                   class="p-2 inpt-disabled"
                   placeholder="Apellidos" [disabled]="true" pInputText
                   id="apellidos" pKeyFilter="alpha"/>
        </div>
        <div class="field col-12 md:col-6 mb-0">
            <label for="telefono">Teléfono</label>
            <input id="telefono" [disabled]="true"
                   class="p-2 inpt-disabled"
                   pInputText
                   [value]="this.personasService.findContactoByTipo(this.personasService.selected().contactos,'TELEFONO_CELULAR')?.contacto"
                   placeholder="####-####"/>
        </div>
        <div class="field col-12 md:col-6 mb-0">
            <label for="correo">Correo Electrónico</label>
            <input id="correo"
                   class="p-2 inpt-disabled"
                   [value]="this.personasService.findContactoByTipo(this.personasService.selected().contactos,'EMAIL')?.contacto"
                   placeholder="Correo eléctronico"
                   [disabled]="true" pInputText
                   pKeyFilter="alpha"/>
        </div>
    </div>
</ng-template>
<!-- Panel para agregar usuario o personas -->
<ng-container *ngIf="this.openDialogPersona">
    <app-usuario-dialog [usuarioDialog]="this.openDialogPersona" [estadoAccionUsuario]="true" [typeAssign]="typeFilter"
                        [headerLabel]="'persona'" [typeActionTo]="typeActionTo" (closeAndSaveDialogUser)="closeDialogUser($event)">
    </app-usuario-dialog>
</ng-container>

